import { useContext } from "react";
import { TranslationContext } from "react-admin";

const useTranslate = () => {
  return useContext(TranslationContext);
};

export default useTranslate;
